import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ColorComparisonPage() {
  return <div className="w-full bg-[#f8f8f8]" data-id="element-713">
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-714">
        <Link to="/" className="flex items-center text-gray-600 hover:text-[#214ae9] transition-colors font-medium" data-id="element-715">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-716" />
          <span data-id="element-717">Go Back</span>
        </Link>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-16" data-id="element-718">
        <div className="text-center mb-12" data-id="element-719">
          <h1 className="text-4xl md:text-5xl font-bold text-[#111111] mb-4" data-id="element-720">
            Color Strategy Options
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-721">
            Explore different approaches to using your brand colors. Each option
            shows a unique hierarchy and emphasis.
          </p>
        </div>

        <div className="space-y-16" data-id="element-722">
          {/* Option 1: Blue Primary (Current) */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-723">
            <div className="bg-[#1a0647] px-8 py-4 border-b border-gray-700" data-id="element-724">
              <h2 className="text-xl font-bold text-white" data-id="element-725">
                Option 1: Blue Primary
              </h2>
              <p className="text-sm text-gray-300" data-id="element-726">
                Professional and trustworthy • Current implementation
              </p>
            </div>
            <div className="p-8" data-id="element-727">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-728">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-729">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-730">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-731">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-732">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-733">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-lg flex items-center space-x-2" data-id="element-734">
                      <span data-id="element-735">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-736" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-737">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-738">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-739">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-740">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-741" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-742">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-743">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-744">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-745">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-746" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-747">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-748">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 2: Purple Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-749">
            <div className="bg-[#b063ff] px-8 py-4 border-b border-purple-400" data-id="element-750">
              <h2 className="text-xl font-bold text-white" data-id="element-751">
                Option 2: Purple Primary
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-752">
                Modern and energetic • Bold personality
              </p>
            </div>
            <div className="p-8" data-id="element-753">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-754">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-755">
                  <div className="inline-block bg-[#00f4f8] bg-opacity-20 text-[#00f4f8] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#00f4f8] border-opacity-30" data-id="element-756">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-757">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-758">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-759">
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg flex items-center space-x-2" data-id="element-760">
                      <span data-id="element-761">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-762" />
                    </button>
                    <button className="border-2 border-[#214ae9] text-[#214ae9] px-6 py-3 rounded-lg font-bold hover:bg-[#214ae9] hover:text-white transition-all" data-id="element-763">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-764">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-765">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-766">
                      <ShieldIcon className="w-6 h-6 text-[#b063ff]" data-id="element-767" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-768">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-769">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-770">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-771">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-772" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-773">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-774">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 3: Cyan Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-775">
            <div className="bg-[#00f4f8] px-8 py-4 border-b border-cyan-300" data-id="element-776">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-777">
                Option 3: Cyan Primary
              </h2>
              <p className="text-sm text-[#111111] text-opacity-70" data-id="element-778">
                Fresh and innovative • High energy
              </p>
            </div>
            <div className="p-8" data-id="element-779">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-780">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-781">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-782">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-783">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-784">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-785">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-[#00d9dd] transition-all shadow-lg flex items-center space-x-2" data-id="element-786">
                      <span data-id="element-787">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-788" />
                    </button>
                    <button className="border-2 border-[#b063ff] text-[#b063ff] px-6 py-3 rounded-lg font-bold hover:bg-[#b063ff] hover:text-white transition-all" data-id="element-789">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-790">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-791">
                    <div className="w-12 h-12 bg-[#00f4f8] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-792">
                      <ShieldIcon className="w-6 h-6 text-[#00f4f8]" data-id="element-793" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-794">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-795">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-796">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-797">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-798" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-799">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-800">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 4: Balanced Trio */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-801">
            <div className="bg-gradient-to-r from-[#214ae9] via-[#b063ff] to-[#00f4f8] px-8 py-4" data-id="element-802">
              <h2 className="text-xl font-bold text-white" data-id="element-803">
                Option 4: Balanced Trio
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-804">
                Equal emphasis • Vibrant and dynamic
              </p>
            </div>
            <div className="p-8" data-id="element-805">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-806">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-807">
                  <div className="inline-block bg-white bg-opacity-10 text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-white border-opacity-20" data-id="element-808">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-809">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-810">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-811">
                    <button className="bg-gradient-to-r from-[#214ae9] to-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:shadow-xl transition-all shadow-lg flex items-center space-x-2" data-id="element-812">
                      <span data-id="element-813">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-814" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-815">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-816">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-817">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-818">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-819" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-820">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-821">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-822">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-823">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-824" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-825">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-826">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 5: High Contrast */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-827">
            <div className="bg-[#111111] px-8 py-4 border-b border-gray-800" data-id="element-828">
              <h2 className="text-xl font-bold text-white" data-id="element-829">
                Option 5: High Contrast
              </h2>
              <p className="text-sm text-gray-400" data-id="element-830">
                Bold and striking • Maximum impact
              </p>
            </div>
            <div className="p-8" data-id="element-831">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-832">
                {/* Hero preview */}
                <div className="bg-[#111111] rounded-xl p-8 border-2 border-[#00f4f8]" data-id="element-833">
                  <div className="inline-block bg-[#00f4f8] text-[#111111] px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-834">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-835">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-836">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-837">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-white transition-all shadow-lg flex items-center space-x-2" data-id="element-838">
                      <span data-id="element-839">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-840" />
                    </button>
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg" data-id="element-841">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-842">
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-843">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-844">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-845" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-846">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-847">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-848">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-849">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-850" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-851">
                      Easy to Use
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-852">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 6: Light & Airy */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-853">
            <div className="bg-white px-8 py-4 border-b-2 border-[#214ae9]" data-id="element-854">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-855">
                Option 6: Light & Airy
              </h2>
              <p className="text-sm text-gray-600" data-id="element-856">
                Minimal and clean • Approachable
              </p>
            </div>
            <div className="p-8" data-id="element-857">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-858">
                {/* Hero preview */}
                <div className="bg-white rounded-xl p-8 border-2 border-gray-200" data-id="element-859">
                  <div className="inline-block bg-[#214ae9] bg-opacity-5 text-[#214ae9] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#214ae9] border-opacity-20" data-id="element-860">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-[#111111] mb-4" data-id="element-861">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-862">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-863">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-md flex items-center space-x-2" data-id="element-864">
                      <span data-id="element-865">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-866" />
                    </button>
                    <button className="bg-white border-2 border-gray-300 text-[#111111] px-6 py-3 rounded-lg font-bold hover:border-[#214ae9] hover:text-[#214ae9] transition-all" data-id="element-867">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-868">
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#214ae9] transition-colors" data-id="element-869">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-870">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-871" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-872">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-873">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#b063ff] transition-colors" data-id="element-874">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-875">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-876" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-877">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-878">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}